import { render, staticRenderFns } from "./RemoveResourceConfirmationDialog.vue?vue&type=template&id=976b00b4"
import script from "./RemoveResourceConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./RemoveResourceConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports